<template>
  <div class="audio-media-content" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <el-table-column prop="name" :label="$t('control.name')"> </el-table-column>
        <el-table-column prop="alias_name" :label="$t('broadcast.system_file_name')"> </el-table-column>
        <el-table-column prop="add_time" :label="$t('control.time')"> </el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? $t('broadcast.add_media') : $t('broadcast.edit_media')"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      :label-width="$i18n.locale==='zh-CN'?'100px':'140px'"
    >
      <el-form
        :model="editOne"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item :label="$t('broadcast.file_name')" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('broadcast.mp3_file')">
            <el-upload
              ref="upload"
              name="file"
              class="avatar-uploader"
              :action="Mp3UploadAction()"
              :limit="1"
              :file-list="fileList"
              :on-success="handleAvatarSuccess"
              :beforeUpload="beforeAvatarUpload"
              :headers = "{
                access_token: hy_access_token
              }"
              :data = "{
                group_id: broadcast_group
              }"
            >
              <el-button size="small" type="primary">{{$t('broadcast.mp3_file_upload')}}</el-button>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="createTask"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button
        >
        <el-button
          type="primary"
          @click="updateTask"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mediaApi from "@/api/audio/media";
const account = {
  broadcast: 'https://ld.foridor.cn/upload.php',
  broadcast_version: 0,
  broadcast_group: 0
}
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: this.$t('broadcast.enter_file_name'), trigger: "blur" }],
      },
      editType: -1,
      editOne: {},
      fileList: [],
      file: "",
      broadcast_version: account.broadcast_version,
      broadcast_group: account.broadcast_group,
      hy_access_token: ''
    };
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
  methods: {
    Mp3UploadAction() {
      let windows_ip = account.broadcast
      if (windows_ip){
        let ishttp=windows_ip.indexOf("http");
        if(ishttp==0){
          return windows_ip;
        }else{
          return 'https://'+windows_ip;
        }
      }else{
        return process.env.VUE_APP_ALARM_API+'/upload.php';
      }
    },
    getTableData(pageIndex) {
      // 获取媒体列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      mediaApi.mediaList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.HyAccessToken()
        }
      });
    },
    HyAccessToken() {
      mediaApi.getHyAccessToken().then((res) => {
        if (res.data.code === 1000) {
          this.hy_access_token = res.data.data.access_token;
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          file_id: 0,
          name: "",
          alias_name: "",
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          file_id: index.file_id,
          name: index.name,
          alias_name: index.alias_name
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateTask() {
      mediaApi.mediaEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.mod_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createTask() {
      mediaApi.mediaAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.add_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          mediaApi.mediaDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },
    handleAvatarSuccess(res) {
      if(this.broadcast_version){
        if (res.code == 200) {
          // this.$message.success(this.$t("control.upload_success"));
          this.editOne.alias_name = res.data.name;
          this.editOne.file_id = res.data.id;
        } else {
          this.$message.error(this.$t("control.error") + res.message);
        }
      }else{
        if (res.cod === 1000 || res.cod === "1000") {
          // this.$message.success(this.$t("control.upload_success"));
          this.editOne.file_id = 0;
          this.editOne.alias_name = res.url;
        } else {
          this.$message.error(this.$t("control.error") + res);
        }
      }
      
    },
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (testmsg === "mp3"||testmsg === "wav") {
        return true;
      }else{
        return this.$message({
          message: this.$t('broadcast.just_mp3'),
          type: "error",
        });
      }
    },
  }
};
</script>
<style lang='less'>
.audio-media-content {
  width: 100%;
  .form-info{
    padding-left:5px;
    padding-right: 0;
    .el-form-item__label{
      width:80px;
    }
  }
}
</style>